import { Component, OnInit, Input, Inject, Injector, OnDestroy, ChangeDetectorRef} from '@angular/core';
import { StepperService } from 'src/app/stepper.service';
import { AirModel } from 'src/app/models/air/air-model';
import { AirComponent } from '../air.component';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';
import { AirSearchService } from 'src/app/services/air/air-search.service';
import { MarketAirProductsModel } from 'src/app/models/air/market-air-products.model';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AirPriceDetailDialogComponent } from 'src/app/components/air-price-detail-dialog/air-price-detail-dialog.component';
import { TariffNotFoundDialogComponent } from 'src/app/components/tariff-not-found-dialog/tariff-not-found-dialog.component';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { SearchLogClickHistoryService } from 'src/app/services/search-log-click-history.service';
import { AirPriceRequestDialogComponent } from 'src/app/components/air-price-request-dialog/air-price-request-dialog.component';
import { Subscription } from 'rxjs';
import { SseService } from 'src/app/services/sse-service';
import { AirCalculatedFreightModel } from 'src/app/models/air/air-calculated-freight.model';
import { NgZone } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-price-request',
  templateUrl: './price-request.component.html',
  styleUrls: ['./price-request.component.scss']
})
export class AirPriceRequestComponent extends BaseFormComponentComponent implements OnInit, OnDestroy {

  @Input("model") model: AirModel;
  adminDialogRef: DynamicDialogRef;
  viewType:string = 'list';
  isDialogPriceOpen = false;
  private messageSubscription: Subscription | null = null;
  showSpinner: boolean = false;
  aiHint: string = null;

  constructor(
    protected injector: Injector, @Inject(AirComponent) public parent: AirComponent, private stepperService: StepperService, private airSearchService: AirSearchService, 
    private searchLogHistoryService: SearchLogClickHistoryService, private sseService: SseService, private cdr: ChangeDetectorRef, private ngZone: NgZone,
    private userService: UserService) {
    super(injector)
    this.parent.isLoading = true;

  }

  async ngOnInit() {


    if(this.messageSubscription) {
      this.messageSubscription?.unsubscribe();
      this.messageSubscription = null;
    }

    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    if (isMobile) {
      this.viewType = "card";
    }
    window.matchMedia("(max-width: 768px)").addEventListener('change', e => {
      this.viewType = e.matches ? "card" : "table";
    });

    if (this.model.selectedProduct && this.parent.showOnlyComponent) {
      this.model.selectedProduct.isSelectedFromList = true;
      if (this.model?.products){
          this.model.products = [this.model.selectedProduct].concat(this.model.products).filter(product => {
              return (!product?.isOverLimit && product.availableCapacity && !product?.freights?.errorCode) || product?.isSelectedFromList;
          });
      }else {
          this.model.products = [];
          this.model.products = [this.model.selectedProduct].concat(this.model.products).filter(product => {
              return (!product?.isOverLimit && product.availableCapacity && !product?.freights?.errorCode) || product?.isSelectedFromList;
          });
      }

    }

    if (this.model?.products){
      this.showSpinner = this.model.products.filter(product => product.hasIntegration).length > 0
    }

    
    
    if(this.parent?.stepper?.notShowReservation) this.parent.stepper.notShowReservation = this.onlyShowPriceRequests();
    if (!this.messageSubscription) { 
          this.messageSubscription =   this.sseService.getMessages().subscribe(message => {
            if (message === 'Search process completed.') {

              this.ngZone.run(() => {
                this.sseService.disconnect();
                this.unsubscribeFromMessages(); 
                this.showSpinner = false; 
                this.cdr.detectChanges(); 
              });

              if(!this.model?.products) return;
           
    
              setTimeout(() => {
                // Online fiyat bulunmayan ürünler fiyat talep et olarak aktif edilir.
                let onlineProductsUniqueById = Array.from(new Map(this.model.products.map(item => [item.id, item])).values()).filter(f => f.hasIntegration);
                if(onlineProductsUniqueById) {
      
                  onlineProductsUniqueById.forEach(p => {
                    let foundOnlineProductWithPrice = this.model.products.find(_p => _p.id == p.id && _p?.freights?.unitPrice && _p?.freights?.unitPrice > 0);
                    if(!foundOnlineProductWithPrice) {
                      let newProduct = { ...p }; 
                        newProduct.hasIntegration = false;
                        newProduct.hasNoOnlinePrice = true;
                        this.model.products = [...this.model.products, newProduct];
                        this.sseService.onChangeProduct.next(newProduct);
                        this.cdr.detectChanges();
                    }
                  })

                  this.getAiHint();

                }
              }, 2000)
             
             
              return;
            }


            if(this.model.isNoPrice) return;
            if(!this.model?.products) return;

          let price = JSON.parse(message) as AirCalculatedFreightModel;
          let product = this.model.products.find(f => f.uuid == price.uuid);

          if (product && price.unitPrice) {
            // Veri güncellemelerini Angular Zone içine alarak UI renderını tetikliyoruz
            this.ngZone.run(() => {
              let newProduct = { ...product };
              if (price.grandTotal) {
                newProduct.hasIntegration = false;
                newProduct.isCompleteOnlinePrice = true;
                newProduct.freights = price;
                newProduct.uuid = price.newProductUuid;
                newProduct.hasOnlinePrice = true;
                newProduct.frontTariff = price.frontTariff;
                newProduct.endTariff = price.endTariff;


               
                
                if (product.dueDates && product.dueDates.length > 0) {
                  const maxPercent = product.dueDates.reduce(
                    (max, current) => (current.percent > max.percent ? current : max),
                    product.dueDates[0]
                  );
                  newProduct.selectedDue = maxPercent;
                }

                const updatedProducts = [...this.model.products, newProduct];


                // Referansı güncelleyip değişikliği algılatıyoruz 
                this.model = {...this.model, products: updatedProducts};
                this.sseService.onChangeProduct.next(newProduct);
                
                this.cdr.markForCheck();
                this.cdr.detectChanges();
              }
            });
          }
        
      
          })
    }

    if(!this.showSpinner) {
      this.getAiHint();
    }
    

    this.sseService.setReady();
  }

    ngOnDestroy() {
      if (this.adminDialogRef) {
          this.adminDialogRef.close();
      }
      this.unsubscribeFromMessages();
    }

  async makeReservation(selectedProduct: MarketAirProductsModel = null, marketProductsDefId = null, productId = null, uuid = null) {

    if(this.isLoading) return; 
    this.isLoading = true;
    if(selectedProduct) this.model.marketProductsDefId = selectedProduct.marketProductsDefId;
    if(!selectedProduct) this.model.marketProductsDefId = marketProductsDefId;

    this.model.selectedProduct = selectedProduct;
    this.model.requestUuid = uuid;
    

    try {

      if (!this.model.selectedProduct || !this.model.selectedProduct.isSelectedFromList) {
        this.model = await this.airSearchService.offer(this.model).toPromise();
      } else {
        this.model = await this.airSearchService.insurance(this.model).toPromise();
      }
      this.isLoading = false;
      this.parent.reservationInfoLoading = true;
      window.scroll({ top: this.parent.initialOffsetTop, left: 0, behavior: 'smooth' });
      this.parent.container.clear();
      this.parent.model = this.model;

      this.stepperService.changeCurrentStep(3);
      this.parent.renderStepComponent(this.parent.stepComponents[3], this.model, 3);

      if(!this.parent.showOnlyComponent) {
        this.addQueryParam("page", "REZ")
      }

    } catch (error) {
      this.model.selectedProduct = null;
      // zaman aşımına uğrayan bir istek gerçekleşti ise bir önceki adıma geri dönüyoruz.
      if (error == 'searchTimeOut') {
        this.parent.container.clear();
        this.stepperService.changeCurrentStep(1);
        window.scroll({ top: this.parent.initialOffsetTop, left: 0, behavior: 'smooth' });
      }

      this.isLoading = false;
      this.parent.reservationInfoLoading = false;
      this.parent.isLoading = false;
    }


  }

  async priceInfo(product: MarketAirProductsModel) {
    if(!product?.freights?.grandTotal || !product?.freights?.unitPrice || product?.freights?.errorCode ) return;
    if (this.isDialogPriceOpen || !product?.freights?.grandTotal) return;
    this.isDialogPriceOpen = true;

    this.ngZone.run(() => {
        this.adminDialogRef = this.dialogService.open(AirPriceDetailDialogComponent, { header: null, showHeader: false, modal: true, width: '800px', height: 'auto', closable: false, data: { product: product, model: this.model, showButton: true } });
    })


    this.adminDialogRef.onClose.subscribe((data) => {
        this.isDialogPriceOpen = false;
          if(data && data.makeReservation) {
            this.makeReservation(data.selectedProduct, data.marketProductsDefId).then(r => {
          })
        }
    });
  }

  onTimeEndAllocatedProduct(product: MarketAirProductsModel) {
    this.model.selectedProduct = null;
    this.parent.container.clear();
    this.stepperService.changeCurrentStep(1);
    this.showMessageStickly('warn', 'searchTimeOut')
    window.scroll({ top: this.parent.initialOffsetTop, left: 0, behavior: 'smooth' });
  }

  frontTariffNotFound(){
    this.adminDialogRef = this.dialogService.open(TariffNotFoundDialogComponent, { header: null, showHeader: false, modal: true, width: '800px', height: 'auto', closable: false, data: {type: "front"}});
  }
  endTariffNotFound(){
    this.adminDialogRef = this.dialogService.open(TariffNotFoundDialogComponent, {  header: null,  showHeader: false, modal: true, width: '800px', height: 'auto', closable: false, data: {type: "end"}});
  }
  frontEndTariffNotFound(){
    this.adminDialogRef = this.dialogService.open(TariffNotFoundDialogComponent, {  header: null,  showHeader: false, modal: true, width: '800px', height: 'auto', closable: false, data: {type: "frontend"}});
  }

  onlyShowPriceRequests() {

    if(!this.model.products) return true;


    const noPriceProductsSize = this.model.products.filter(product =>   ((((product?.isOverLimit && !product?.isSelectedFromList) ||  !product?.availableCapacity || product?.freights?.errorCode)) ))

    if(noPriceProductsSize.length == this.model.products.length) return true;

    return false;

  }
  onSelectViewType(viewType:string) {
    this.viewType = viewType;

    this.createClickHistory(viewType);
  }

    createClickHistory(viewType: string): void {
        const model = new SearchLogClickHistoryModel();
        model.viewType = this.mapViewType(viewType);
        model.searchLogId = this.model?.id || null;

        this.searchLogHistoryService.create(model).toPromise();
      }

      private mapViewType(type: string): string {
        switch (type) {
          case 'card': return 'CARDVIEW';
          case 'list': return 'LISTVIEW';
          default: return type.toUpperCase();
        }
      }


      async priceRequest(product: MarketAirProductsModel) {
    
        this.isDialogPriceOpen = true;
  
        this.ngZone.run(() => {
          this.adminDialogRef = this.dialogService.open(AirPriceRequestDialogComponent, { header: null, showHeader: false, modal: true, width: '1000px', height: 'auto', closable: false, data: { product: product, model: this.model, parentComponent: this, showButton: true } });
        })


        this.adminDialogRef.onClose.subscribe((data) => {
          this.isDialogPriceOpen = false;
          if(data?.products) {
            this.makeReservation(null, data?.products?.marketProductsDefId, null, null).then(r => {})
          }
        });
          
      }

    private unsubscribeFromMessages(): void {
      if (this.messageSubscription) {
        this.messageSubscription.unsubscribe();
        this.messageSubscription = null;
      }
    }

        public getAiHint() {
          return;
        let user = this.userService.getLocale();
        if (user && ['weld-int.com', 'weld.com', 'xinerji.com', 'dff-tech.com'].includes(user.email.split('@')[1])) {
          if(this.model.products && this.model.products.length > 0) {
            this.airSearchService.getAiHint(this.mapToProductsAiRequest()).toPromise().then(r => {
              this.aiHint = r; 
            })
          }
        }
      }

        public mapToProductsAiRequest() {

        const aiHintReqModel = {
          fromCity: this.model?.departureCity?.name,
          toCity: this.model?.arrivalCity?.name,
          products: []
        }
        
        
     
       const products =  this.model.products.reduce((acc, product) => {
          const f = product.freights;
          if (f && f.unitPrice != null) {           
            acc.push({
              etd: f.etd,
              eta: f.eta,
              cutOffDate: f.cutOffDate,
              grandTotal: f.grandTotal,
              airline: (f.airline || product.airline),
              airInfo: f.airInfo,
              transitTime: (product.transitTime || f.transitTime),
              uuid: (f.uuid || product.uuid),
            });
          }

          return acc;
        }, [] as any[]);

        aiHintReqModel.products = products;

        console.log(this.model.products, aiHintReqModel);

   
        return aiHintReqModel;
      }
      
   
}
